import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { TableBox, ButtonBasic, ButtonClose, CheckboxToggle } from '@lk-gtcom/ecomlab-components';
import { ModalAddMassLink } from '../../../pages/AddCompetitors/ModalAddMassLink/ModalAddMassLink';
import './ModalAddMpSimple.scss';
import useGeneralStore from '../../../store/general';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import usePushStore from '../../../store/toast';
import { TextPage } from '../../../components/TextPage/TextPage';
import { useDataTable } from '../../../common/hooks';
import { useResponseHandler } from '../../../common/auth';
import import_icon from './img/bx-import.svg';
import refresh_icon from './img/bx-refresh.svg';

const ModalAddMpSimple = ({
  selectedApi,
  selectedMp,
  currentCompetitor,
  setCurrentCompetitor,
  setIsModal,
  fetchChangeStatus
}) => {

  const refContainer = useRef()
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const [name, setName] = useState(currentCompetitor?.['Наименование'] || '');
  const [offerId, setOfferId] = useState(currentCompetitor?.['Артикул'] || '');
  const [active, setActive] = useState(currentCompetitor?.['Активна']?.[0] || false)
  const [prodId, setProdId] = useState(currentCompetitor?.product_id || null);
  const [data, setData] = useState(null)

  const [clientData, setClientData] = useState(null)
  const [selectedItems, setSelectedItems] = useState([])

  // Таблица 
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs

  // Модалка
  const [isModalAddMassLink, setIsModalAddMassLink] = useState(false)
  const addPush = usePushStore((state) => state.addPush);

  const offerIdHint =
    'Разрешены английские и русские буквы (кроме ё), цифры, и символы .,/()[]-=_ (без пробелов). Максимальная длина — 50 знаков';

  // Добавление ссылок
  const fetchAddLinks = (links = []) => {
    // const url = `https://apps1.ecomru.ru:4655/v1/product-competitor/urls/add-list`;
    const url = `https://appche1.ecomru.ru:4348/api/links/mp/create`

    const body = JSON.stringify({
      // master_name: name,
      // master_sku: offerId,
      // links,
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: currentCompetitor?.['Артикул'],
      // competitor_urls: links,
      links: links
    });

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const addErrorPush = (text = 'Неизвестная ошибка') => {
            addPush({
              type: 'error',
              title: 'Ошибка',
              message: text,
              timeout: 3000,
            });
          };
          addErrorPush();
          const err = res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const addSuccessPush = (message = "Ссылки успешно добавлены") => {
          addPush({
            type: 'success',
            title: 'Информация',
            message: message,
            timeout: 5000,
          });
        };
        addSuccessPush()
        setClientData(json)
      })
      .catch((e) => console.error(e))
  }

  // Список актуальных ссылок
  const fetchData = (params, abortController = new AbortController()) => {
    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `https://apps1.ecomru.ru:4655/v1/product-competitor/urls/get-list`

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam,
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: currentCompetitor?.['Артикул']
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad table response');
        }
      })
      .then((json) => {
        setData(json);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        if (abortController.signal.aborted) return;
      });
  };

  // Список актуальных ссылок
  const fetchTableData = (params, abortController = new AbortController()) => {
    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `https://appche1.ecomru.ru:4348/api/links/mp${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`

    const body = JSON.stringify({
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: currentCompetitor?.['Артикул'],
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Статус ссылки 
  const fetchChangeStatusLink = (id, status) => {
    const url = `https://appche1.ecomru.ru:4348/api/links/mp/status`;

    const body = JSON.stringify({
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: currentCompetitor?.['Артикул'],
      id,
      status: status
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        console.log('Статус успешно изменен')
        setTimeout(() => fetchTableData(), 500)
      })
      .catch(handleRequestError)
      .finally(() => { });
  };

  // Удаление ссылок 
  const fetchDeleteLink = (id_list) => {
    const url = `https://appche1.ecomru.ru:4348/api/links/mp/delete`;

    const body = JSON.stringify({
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: currentCompetitor?.['Артикул'],
      id_list
    });

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        setSelectedItems([])
        setTimeout(() => fetchTableData(), 500)
      })
      .catch(handleRequestError)
  };

  const handleCheck = (data) => {
    setSelectedItems(data)
  }

  const onToggle = (e) => {
    const status = e?.active?.[0]
    const id = e?.active?.[1]
    fetchChangeStatusLink(id, !status)
  };

  const contextMenuArr = [
    {
      label: 'Удалить',
      onClick: ({ link_id }) => {
        fetchDeleteLink([link_id])
      },
    },
  ];

  useEffect(() => {
    if (clientData?.client_id || currentCompetitor) {
      setIsModalAddMassLink(false)
      fetchData()
      fetchTableData()
    }
  }, [clientData, currentCompetitor]);

  return (
    <>
      {isModalAddMassLink && <ModalAddMassLink
        fetchAddLinks={fetchAddLinks}
        setIsModal={(e) => setIsModalAddMassLink(e)}
      />}

      <div
        className="blackout"
        onClick={(e) => {
          e.stopPropagation()
          let el = e.target;
          if (el.classList.contains('blackout')) {
            setCurrentCompetitor(null)
            setIsModal(false);
          }
        }}
      >
        <div className="modal-add-mp-simple">
          <header className="modal-add-mp-simple__header">
            <TitlePage
              title={`Информация по товару`}
            />

            <CheckboxToggle
              text={active ? ' Активен' : ' Не активен'}
              value={active}
              onChange={(checked) => {
                setActive(!checked)
                fetchChangeStatus(!checked, currentCompetitor?.['Артикул'])
              }}
            />

            <ButtonClose
              onClick={(e) => {
                setCurrentCompetitor(null)
                setIsModal(false)
              }}
            />
          </header>

          <div className="modal-add-mp-simple__content">
            <div className="modal-add-mp-simple__card">
              <img alt='Фото товара' src={data?.primary_image} />

              <div className="modal-add-mp-simple__card-info">
                <TextPage
                  style={{ color: '#636d65' }}
                  text={
                    <>
                      Товар: <span style={{ fontWeight: 700, color: '#000' }}>{data?.product_name}</span>
                    </>
                  }
                />

                <TextPage
                  style={{ color: '#636d65' }}
                  text={
                    <>
                      Категория: <span style={{ fontWeight: 700, color: '#000' }}>{data?.category_name}</span>
                    </>
                  }
                />

                <TextPage
                  style={{ color: '#636d65' }}
                  text={
                    <>
                      Бренд: <span style={{ fontWeight: 700, color: '#000' }}>{data?.brand_name}</span>
                    </>
                  }
                />
              </div>
            </div>

            {/* Добавленный блок для отображения ссылок */}
            <div ref={refContainer}>

              <TableBox
                {...tableProps}
                refContainer={refContainer}
                paginator={true}
                ref={paginatorRef}
                fetchCallback={fetchTableData}
                onToggle={onToggle}
                contextMenuArr={contextMenuArr}
                onCheck={handleCheck}
                child={
                  <>
                    <ButtonBasic
                      whiteGreen
                      width="160px"
                      icon={import_icon}
                      text={'Импорт ссылок'}
                      onClick={(e) => setIsModalAddMassLink(true)}
                      size="32px"
                    />

                    <ButtonBasic
                      whiteGreen
                      minWidth="auto"
                      width="160px"
                      icon={refresh_icon}
                      text={'Обновить'}
                      onClick={(e) => fetchTableData()}
                      size="32px"
                    />

                    <ButtonBasic
                      red
                      minWidth="auto"
                      width="160px"
                      text={'Удалить выбранные'}
                      onClick={(e) => {
                        const current_list_id = selectedItems.map((el) => el?.link_id)
                        fetchDeleteLink(current_list_id)
                      }}
                      size="32px"
                      disabled={!selectedItems.length}
                    />
                  </>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { ModalAddMpSimple };
